import { NavLink, Outlet, useOutletContext } from 'react-router-dom';
import { FileStack, Package } from 'lucide-react';
import type { AppShellContext } from '@/components/layout/AppShell';
import { cn } from '@/lib/utils';
import { t } from '@/i18n';

const TABS = [
  { to: '', end: true, icon: FileStack, labelKey: 'magazyn.tabs.wz' },
  { to: 'pozycje', end: false, icon: Package, labelKey: 'magazyn.tabs.pozycje' },
] as const;

/**
 * Tabbed shell for the warehouse (WZ delivery notes) section — structural
 * copy of FiscalLayout: pill-nav tabs + <Outlet context> passthrough.
 */
export function MagazynLayout() {
  const context = useOutletContext<AppShellContext>();

  return (
    <div className="flex flex-col gap-4">
      <h1 className="text-xl font-semibold">{t('magazyn.title')}</h1>

      <nav aria-label={t('magazyn.title')} className="bg-muted inline-flex items-center gap-1 self-start rounded-lg p-1">
        {TABS.map((tab) => (
          <NavLink
            key={tab.to}
            to={tab.to || '.'}
            end={tab.end}
            className={({ isActive }) =>
              cn(
                'flex items-center gap-1.5 rounded-md px-3 py-1.5 text-sm font-medium transition-colors',
                isActive
                  ? 'bg-background text-foreground shadow-sm'
                  : 'text-muted-foreground hover:text-foreground',
              )
            }
          >
            <tab.icon className="size-4" />
            {t(tab.labelKey)}
          </NavLink>
        ))}
      </nav>

      <Outlet context={context} />
    </div>
  );
}
